var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Benvenenuto su BuonaCaccia admin!")]),_c('b-row',[_c('b-col',[_c('b-card',[_vm._v(" Admin dashboard... ")])],1),_c('b-col',{attrs:{"cols":"4"}},[_c('bc-newsfeed',{attrs:{"tweets":"5"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }